import { defineStore } from 'pinia'
import { store } from '@/store'
import Storage from '@/utils/Storage'
import { getHadGoodsCity } from '@/api/goods'
import { convertPinyin } from '@/utils/chineseHelper'

type CityTypes = {
  code: number | null
  letter: string
  name: string
}

interface State {
  currentSelectRegion: CityTypes
  historySelect: CityTypes[]
  historyGoodsSearch: any[]
}

export const useRegionStore = defineStore({
  id: 'region',
  state: (): State => ({
    currentSelectRegion: Storage.get('CURRENT_SELECT_CITY') || {
      code: null,
      letter: '',
      name: '',
    },
    historySelect: [],
    historyGoodsSearch: [],
  }),
  actions: {
    // async fetchHadGoodsCity() {
    //   const { dataList = [] } = await getHadGoodsCity()
    //   const letterList: string[] = []
    //   const map = new Map()
    //   const newDataList = dataList.map((item: any) => {
    //     const letter = convertPinyin(item.name).match(/^./)[0]
    //     letterList.push(letter)
    //     return {
    //       ...item,
    //       letter,
    //     }
    //   })
    //   for (const letter of letterList) {
    //     map.set(letter, { label: letter, citys: [] })
    //   }
    //   for (const item of newDataList) {
    //     const mapItem = map.get(item.letter)
    //     if (item.letter === mapItem.label) {
    //       mapItem.citys.push(item)
    //     }
    //   }
    // },
    getHistorySelect() {
      this.currentSelectRegion = Storage.get('CURRENT_SELECT_CITY')
      this.historySelect = Storage.get('HISTORY_SELECT_CITYS') || []
    },
    getGoodsSearchHistory() {
      this.historyGoodsSearch = Storage.get('GOODS_SEARCH_HISTORY') || []
    },
    setCurrentSelectRegion(value: CityTypes) {
      this.currentSelectRegion = value
      Storage.set('CURRENT_SELECT_CITY', value)
    },
    setHistorySelect(value: any) {
      console.log('this.historySelect==>', this.historySelect)
      const index = this.historySelect.findIndex(
        (item) => item.name === value.name
      )
      if (index > -1) {
        this.historySelect.splice(index, 1)
        this.historySelect.splice(0, 0, value)
      } else {
        if (this.historySelect.length === 5) {
          this.historySelect.splice(4, 1)
        }
        this.historySelect.splice(0, 0, value)
      }
      Storage.set('HISTORY_SELECT_CITYS', this.historySelect)
    },
    setGoodsSearchHistory(value: any) {
      const index = this.historyGoodsSearch.findIndex((item) => item === value)
      if (index > -1) {
        this.historyGoodsSearch.splice(index, 1)
        this.historyGoodsSearch.splice(0, 0, value)
      } else {
        if (this.historyGoodsSearch.length === 5) {
          this.historyGoodsSearch.splice(4, 1)
        }
        this.historyGoodsSearch.splice(0, 0, value)
      }
      // this.historyGoodsSearch.push(value)
      console.log('this.historyGoodsSearch==>', this.historyGoodsSearch)
      Storage.set('GOODS_SEARCH_HISTORY', this.historyGoodsSearch)
    },
    removeHistoryRegion() {
      Storage.remove('CURRENT_SELECT_CITY')
      Storage.remove('HISTORY_SELECT_CITYS')
      this.getHistorySelect()
    },
    removeHistoryGood() {
      Storage.remove('GOODS_SEARCH_HISTORY')
      this.getGoodsSearchHistory()
    },
  },
})

// 在组件setup函数外使用
export function useRegionStoreWithOut() {
  return useRegionStore(store)
}
